"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMembershipTemplatesAsSelectInputOptions = exports.getAvailableStylesheetsAsSelectInputOptions = exports.getAttachedStylesheetsAsImmutableList = exports.formatForDragAndDrop = exports.formatAsSelectInputOptions = exports.getFetchStylesheetsRequestStatus = exports.getFetchMembershipTemplatesRequestStatus = exports.getFetchBlogTemplatesRequestStatus = exports.getFetchSystemTemplatesRequestStatus = exports.getFetchSubscriptionTemplatesRequestStatus = exports.getUnsubscribeTemplateIdByPath = exports.getUnsubscribeConfirmationTemplateIdByPath = exports.getSubscriptionPreferenceTemplateIdByPath = exports.getUnsubscribeConfirmationTemplatesAsSelectInputOptions = exports.getUnsubscribeTemplatesAsSelectInputOptions = exports.getSubscriptionPreferenceTemplatesAsSelectInputOptions = exports.getSearchResultsPagesAsSelectInputOptions = exports.getPasswordPagesAsSelectInputOptions = exports.get500PagesAsSelectInputOptions = exports.get404PagesAsSelectInputOptions = exports.getBlogTemplatesAsSelectInputOptions = exports.getStylesheets = exports.getUnsubscribeConfirmationTemplates = exports.getUnsubscribeTemplates = exports.getSubscriptionPreferenceTemplates = exports.getBlogTemplates = exports.getSearchResultsPages = exports.getPasswordPages = exports.getErrorPages = exports.getMembershipTemplates = exports.getDesignTemplates = void 0;

var _reselect = require("reselect");

var _sorts = require("settings-ui-sdk/utils/sorts");

var _immutable = require("immutable");

var _I18n = _interopRequireDefault(require("I18n"));

var _TemplateTypes = require("./TemplateTypes");

var _getRequestStatus = _interopRequireDefault(require("settings-ui-sdk/RequestStatuses/getRequestStatus"));

var _actions = require("./actions");

var _constants = require("./constants");

var _Routes = _interopRequireDefault(require("ContentUtils/Routes"));

var _DesignAssetTypes = _interopRequireDefault(require("ContentUtils/constants/DesignAssetTypes"));

var getDropdownText = function getDropdownText(label, folder) {
  if (folder) {
    return label + " (" + _I18n.default.text('marketing.pages.dropdownText.folderName', {
      folderName: folder
    }) + ")";
  }

  return label;
};

var getDesignTemplates = function getDesignTemplates(state) {
  return state.designTemplates.get('templates');
};

exports.getDesignTemplates = getDesignTemplates;

var getMembershipTemplates = function getMembershipTemplates(state) {
  return state.designTemplates.get('membershipTemplates');
};

exports.getMembershipTemplates = getMembershipTemplates;
var getErrorPages = (0, _reselect.createSelector)([getDesignTemplates], function (designTemplates) {
  return designTemplates.filter(function (template) {
    return template.get(_constants.TEMPLATE_TYPE) === _TemplateTypes.ERROR_PAGE;
  });
});
exports.getErrorPages = getErrorPages;
var getPasswordPages = (0, _reselect.createSelector)([getDesignTemplates], function (designTemplates) {
  return designTemplates.filter(function (template) {
    return template.get(_constants.TEMPLATE_TYPE) === _TemplateTypes.PASSWORD_PAGE;
  });
});
exports.getPasswordPages = getPasswordPages;
var getSearchResultsPages = (0, _reselect.createSelector)([getDesignTemplates], function (designTemplates) {
  return designTemplates.filter(function (template) {
    return template.get(_constants.TEMPLATE_TYPE) === _TemplateTypes.SEARCH_RESULTS;
  });
});
exports.getSearchResultsPages = getSearchResultsPages;
var getBlogTemplates = (0, _reselect.createSelector)([getDesignTemplates], function (designTemplates) {
  return designTemplates.filter(function (template) {
    return template.get(_constants.TEMPLATE_TYPE) === _TemplateTypes.BLOG_LISTING || template.get(_constants.TEMPLATE_TYPE) === _TemplateTypes.BLOG_POST;
  });
});
exports.getBlogTemplates = getBlogTemplates;
var getSubscriptionPreferenceTemplates = (0, _reselect.createSelector)([getDesignTemplates], function (designTemplates) {
  return designTemplates.filter(function (template) {
    return template.get(_constants.TEMPLATE_TYPE) == _TemplateTypes.SUBSCRIPTION_PREFERENCES;
  });
});
exports.getSubscriptionPreferenceTemplates = getSubscriptionPreferenceTemplates;
var getUnsubscribeTemplates = (0, _reselect.createSelector)([getDesignTemplates], function (designTemplates) {
  return designTemplates.filter(function (template) {
    return template.get(_constants.TEMPLATE_TYPE) == _TemplateTypes.UNSUBSCRIBE_SIMPLE;
  });
});
exports.getUnsubscribeTemplates = getUnsubscribeTemplates;
var getUnsubscribeConfirmationTemplates = (0, _reselect.createSelector)([getDesignTemplates], function (designTemplates) {
  return designTemplates.filter(function (template) {
    return template.get(_constants.TEMPLATE_TYPE) == _TemplateTypes.UNSUBSCRIBE_CONFIRMATION;
  });
});
exports.getUnsubscribeConfirmationTemplates = getUnsubscribeConfirmationTemplates;
var getStylesheets = (0, _reselect.createSelector)([getDesignTemplates], function (designTemplates) {
  return designTemplates.filter(function (template) {
    return template.get(_constants.TEMPLATE_TYPE) === _TemplateTypes.STYLESHEET;
  });
});
exports.getStylesheets = getStylesheets;
var getBlogTemplatesAsSelectInputOptions = (0, _reselect.createSelector)([getBlogTemplates], function (blogTemplates) {
  var templateLayouts = blogTemplates.filter(function (template) {
    return template.get(_constants.IS_FROM_LAYOUT);
  });
  var templateFiles = blogTemplates.filter(function (template) {
    return !template.get(_constants.IS_FROM_LAYOUT);
  });
  return [{
    text: _I18n.default.text('marketing.blog.inputLabels.templateLayouts'),
    value: 'template-layouts',
    options: templateLayouts.reduce(function (acc, template) {
      acc.push({
        text: template[_constants.LABEL],
        value: template[_constants.PATH]
      });
      return acc;
    }, []).sort(function (a, b) {
      return (0, _sorts.alphanumericSort)(a.text, b.text);
    })
  }, {
    text: _I18n.default.text('marketing.blog.inputLabels.templateFiles'),
    value: 'template-files',
    options: templateFiles.reduce(function (acc, template) {
      acc.push({
        text: template[_constants.LABEL],
        value: template[_constants.PATH]
      });
      return acc;
    }, []).sort(function (a, b) {
      return (0, _sorts.alphanumericSort)(a.text, b.text);
    })
  }];
});
exports.getBlogTemplatesAsSelectInputOptions = getBlogTemplatesAsSelectInputOptions;
var getErrorPagesAsSelectInputOptions = (0, _reselect.createSelector)([getErrorPages], function (errorPages) {
  return errorPages.reduce(function (acc, errorPage) {
    acc.push({
      text: getDropdownText(errorPage[_constants.LABEL], errorPage[_constants.FOLDER]),
      value: errorPage[_constants.PATH]
    });
    return acc;
  }, []).sort(function (opt1, opt2) {
    return opt1.text.localeCompare(opt2.text);
  });
});
var get404PagesAsSelectInputOptions = (0, _reselect.createSelector)([getErrorPagesAsSelectInputOptions], function (errorPages) {
  var default404PageOption = {
    text: _I18n.default.text('marketing.pages.defaultTemplates.errorPage404'),
    value: _TemplateTypes.DEFAULT_TEMPLATE
  };
  return [default404PageOption].concat(errorPages);
});
exports.get404PagesAsSelectInputOptions = get404PagesAsSelectInputOptions;
var get500PagesAsSelectInputOptions = (0, _reselect.createSelector)([getErrorPagesAsSelectInputOptions], function (errorPages) {
  var default500PageOption = {
    text: _I18n.default.text('marketing.pages.defaultTemplates.errorPage500'),
    value: _TemplateTypes.DEFAULT_TEMPLATE
  };
  return [default500PageOption].concat(errorPages);
});
exports.get500PagesAsSelectInputOptions = get500PagesAsSelectInputOptions;
var getPasswordPagesAsSelectInputOptions = (0, _reselect.createSelector)([getPasswordPages], function (passwordPages) {
  return passwordPages.reduce(function (acc, passwordPromptPage) {
    acc.push({
      text: getDropdownText(passwordPromptPage[_constants.LABEL], passwordPromptPage[_constants.FOLDER]),
      value: passwordPromptPage[_constants.PATH]
    });
    return acc;
  }, []).sort(function (opt1, opt2) {
    return opt1.text.localeCompare(opt2.text);
  });
});
exports.getPasswordPagesAsSelectInputOptions = getPasswordPagesAsSelectInputOptions;
var getSearchResultsPagesAsSelectInputOptions = (0, _reselect.createSelector)([getSearchResultsPages], function (searchResultPages) {
  return searchResultPages.reduce(function (acc, searchResultPage) {
    acc.push({
      text: getDropdownText(searchResultPage[_constants.LABEL], searchResultPage[_constants.FOLDER]),
      value: searchResultPage[_constants.PATH]
    });
    return acc;
  }, []).sort(function (opt1, opt2) {
    return opt1.text.localeCompare(opt2.text);
  });
});
exports.getSearchResultsPagesAsSelectInputOptions = getSearchResultsPagesAsSelectInputOptions;
var getSubscriptionPreferenceTemplatesAsSelectInputOptions = (0, _reselect.createSelector)([getSubscriptionPreferenceTemplates], function (templates) {
  return templates.reduce(function (acc, template) {
    acc.push({
      text: getDropdownText(template[_constants.LABEL], template[_constants.FOLDER]),
      value: template[_constants.PATH]
    });
    return acc;
  }, [{
    text: _I18n.default.text('marketing.pages.defaultTemplates.subscriptions'),
    value: _TemplateTypes.DEFAULT_TEMPLATE
  }]).sort(function (opt1, opt2) {
    return opt1.text.localeCompare(opt2.text);
  });
});
exports.getSubscriptionPreferenceTemplatesAsSelectInputOptions = getSubscriptionPreferenceTemplatesAsSelectInputOptions;
var getUnsubscribeTemplatesAsSelectInputOptions = (0, _reselect.createSelector)([getUnsubscribeTemplates], function (templates) {
  return templates.reduce(function (acc, template) {
    acc.push({
      text: getDropdownText(template[_constants.LABEL], template[_constants.FOLDER]),
      value: template[_constants.PATH]
    });
    return acc;
  }, [{
    text: _I18n.default.text('marketing.pages.defaultTemplates.unsubscribe'),
    value: _TemplateTypes.DEFAULT_TEMPLATE
  }]).sort(function (opt1, opt2) {
    return opt1.text.localeCompare(opt2.text);
  });
});
exports.getUnsubscribeTemplatesAsSelectInputOptions = getUnsubscribeTemplatesAsSelectInputOptions;
var getUnsubscribeConfirmationTemplatesAsSelectInputOptions = (0, _reselect.createSelector)([getUnsubscribeConfirmationTemplates], function (templates) {
  return templates.reduce(function (acc, template) {
    acc.push({
      text: getDropdownText(template[_constants.LABEL], template[_constants.FOLDER]),
      value: template[_constants.PATH]
    });
    return acc;
  }, [{
    text: _I18n.default.text('marketing.pages.defaultTemplates.unsubscribeConfirmation'),
    value: _TemplateTypes.DEFAULT_TEMPLATE
  }]).sort(function (opt1, opt2) {
    return opt1.text.localeCompare(opt2.text);
  });
});
exports.getUnsubscribeConfirmationTemplatesAsSelectInputOptions = getUnsubscribeConfirmationTemplatesAsSelectInputOptions;

var findInTemplatesByPath = function findInTemplatesByPath(templatesSelector) {
  return function (path) {
    return (0, _reselect.createSelector)([templatesSelector], function (templates) {
      var templateOrNull = templates.find(function (template) {
        return template[_constants.PATH] === path;
      });

      if (templateOrNull) {
        if (templateOrNull[_constants.IS_FROM_LAYOUT]) {
          return templateOrNull[_constants.GENERATED_FROM_LAYOUT_ID];
        } else {
          return templateOrNull[_constants.ID];
        }
      }

      return null;
    });
  };
};

var getSubscriptionPreferenceTemplateIdByPath = findInTemplatesByPath(getSubscriptionPreferenceTemplates);
exports.getSubscriptionPreferenceTemplateIdByPath = getSubscriptionPreferenceTemplateIdByPath;
var getUnsubscribeConfirmationTemplateIdByPath = findInTemplatesByPath(getUnsubscribeConfirmationTemplates);
exports.getUnsubscribeConfirmationTemplateIdByPath = getUnsubscribeConfirmationTemplateIdByPath;
var getUnsubscribeTemplateIdByPath = findInTemplatesByPath(getUnsubscribeTemplates);
exports.getUnsubscribeTemplateIdByPath = getUnsubscribeTemplateIdByPath;
var getFetchSubscriptionTemplatesRequestStatus = (0, _getRequestStatus.default)(_actions.DesignTemplatesActionTypes.FETCH_SUBSCRIPTION_TEMPLATES);
exports.getFetchSubscriptionTemplatesRequestStatus = getFetchSubscriptionTemplatesRequestStatus;
var getFetchSystemTemplatesRequestStatus = (0, _getRequestStatus.default)(_actions.DesignTemplatesActionTypes.FETCH_SYSTEM_TEMPLATES);
exports.getFetchSystemTemplatesRequestStatus = getFetchSystemTemplatesRequestStatus;
var getFetchBlogTemplatesRequestStatus = (0, _getRequestStatus.default)(_actions.DesignTemplatesActionTypes.FETCH_BLOG_TEMPLATES);
exports.getFetchBlogTemplatesRequestStatus = getFetchBlogTemplatesRequestStatus;
var getFetchMembershipTemplatesRequestStatus = (0, _getRequestStatus.default)(_actions.DesignTemplatesActionTypes.FETCH_MEMBERSHIP_TEMPLATES);
exports.getFetchMembershipTemplatesRequestStatus = getFetchMembershipTemplatesRequestStatus;

var getAttachedStylesheets = function getAttachedStylesheets(state, props) {
  var allStylesheets = getStylesheets(state);
  return props.attachedStylesheetIds.map(function (id) {
    return allStylesheets.get(id);
  });
};

var getAvailableStylesheets = function getAvailableStylesheets(state, props) {
  var availableStylesheets = getStylesheets(state);
  props.attachedStylesheetIds.forEach(function (id) {
    availableStylesheets = availableStylesheets.delete(id);
  });
  return availableStylesheets;
};

var getFetchStylesheetsRequestStatus = (0, _getRequestStatus.default)(_actions.DesignTemplatesActionTypes.FETCH_STYLESHEETS);
exports.getFetchStylesheetsRequestStatus = getFetchStylesheetsRequestStatus;

var formatAsSelectInputOptions = function formatAsSelectInputOptions(stylesheets) {
  return stylesheets.reduce(function (acc, stylesheet) {
    acc.push({
      value: stylesheet.get(_constants.ID),
      text: stylesheet.get(_constants.LABEL)
    });
    return acc;
  }, []).sort(function (opt1, opt2) {
    return opt1.text.localeCompare(opt2.text);
  });
};

exports.formatAsSelectInputOptions = formatAsSelectInputOptions;

var getTemplateLink = function getTemplateLink(stylesheet) {
  if (stylesheet.generatedFromLayoutId) {
    return _Routes.default.designManager(stylesheet.generatedFromLayoutId, _DesignAssetTypes.default.LAYOUT);
  }

  return _Routes.default.designManager(stylesheet.id, _DesignAssetTypes.default.TEMPLATE);
};

var formatForDragAndDrop = function formatForDragAndDrop(stylesheets) {
  return stylesheets.reduce(function (acc, stylesheet, index) {
    return acc.push({
      index: index,
      link: getTemplateLink(stylesheet),
      value: stylesheet.get(_constants.ID),
      text: stylesheet.get(_constants.LABEL),
      readOnly: stylesheet.get(_constants.IS_READ_ONLY)
    });
  }, (0, _immutable.List)());
};

exports.formatForDragAndDrop = formatForDragAndDrop;
var getAttachedStylesheetsAsImmutableList = (0, _reselect.createSelector)([getAttachedStylesheets], function (stylesheets) {
  return formatForDragAndDrop(stylesheets);
});
exports.getAttachedStylesheetsAsImmutableList = getAttachedStylesheetsAsImmutableList;
var getAvailableStylesheetsAsSelectInputOptions = (0, _reselect.createSelector)([getAvailableStylesheets], function (stylesheets) {
  return formatAsSelectInputOptions(stylesheets);
});
exports.getAvailableStylesheetsAsSelectInputOptions = getAvailableStylesheetsAsSelectInputOptions;

var getTemplatesOfType = function getTemplatesOfType(templates, templateType) {
  return templates.filter(function (template) {
    return template.get(_constants.TEMPLATE_TYPE) === templateType;
  });
};

var getTemplatesAsSelectInputOptions = function getTemplatesAsSelectInputOptions(templates) {
  return templates.reduce(function (acc, template) {
    acc.push({
      text: getDropdownText(template[_constants.LABEL], template[_constants.FOLDER]),
      value: template[_constants.ID]
    });
    return acc;
  }, []);
};

var defaultOption = function defaultOption(key) {
  return {
    text: _I18n.default.text("contentMembership.defaultTemplates." + key),
    value: null
  };
};

var getMembershipTemplatesAsSelectInputOptions = function getMembershipTemplatesAsSelectInputOptions(type, defaultLangKey) {
  return (0, _reselect.createSelector)([getMembershipTemplates], function (templates) {
    return [defaultOption(defaultLangKey)].concat(getTemplatesAsSelectInputOptions(getTemplatesOfType(templates, type)));
  });
};

exports.getMembershipTemplatesAsSelectInputOptions = getMembershipTemplatesAsSelectInputOptions;